module.exports = __webpack_public_path__ + "static/media/logo-192.c07f63fb.webp";